import React, { useState } from "react";
import { Icon, Table, Button, Alert } from "antd";
import ModalComponent from "../modalComponent/ModalComponent";
import UploadForm from "../upload/UploadForm";
import { visitApiUpsellProvider } from "../../lib/api/providers";
const AddMedia = ({ before = false, after = false, visitId = "", visitPath }) => {
  const [modalVisible, setModalVisible] = useState(false);
  return (
    <div>
      <Button
        type="primary"
        shape="circle"
        onClick={() => {
          setModalVisible(!modalVisible);
        }}
      >
        Ajouter
      </Button>
      <ModalComponent title={"Ajouter une photo"} visible={modalVisible} closeModal={() => setModalVisible(false)}>
        <UploadForm
          onUploadComplete={async (fileData, err) => {
            if (!err) {
              const fileName = fileData.Key || fileData.key;
              try {
                await visitApiUpsellProvider.post(`/${visitId}/media`, {
                  ...visitPath,
                  mediaType: "Photo",
                  mediaProps: {
                    before,
                    after,
                    url: fileName,
                    urlResized: fileName
                  }
                });
                setModalVisible(false);
                //reload page
                window.location.reload(false);
              } catch (e) {
                window.alert(e.message);
              }
            }
          }}
        />
      </ModalComponent>
    </div>
  );
};

export default AddMedia;



// WEBPACK FOOTER //
// src/components/visit/AddMedia.js